import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
import { SingleStepSportEventParticipantsFragmentDoc } from './SingleStepSportEventParticipants.fragment';
import { SportEventOffersV2FragmentDoc } from './SportEventOffersV2.fragment';
export type SingleStepSportEventFragment = {
	__typename: 'SingleStepSportEvent';
	id: string;
	objectType: Types.ObjectType;
	objectId: number;
	sport: Types.SportType;
	offerCount: number;
	content: {
		__typename?: 'SingleStepSportEventContent';
		name: string;
		status: Types.SportEventStatus;
		startAt: any;
		endAt?: any | null;
		fullPath?: string | null;
		venue?: { __typename?: 'SportVenue'; venueID: number; name: string } | null;
		competitionStage: {
			__typename?: 'SportCompetitionStageV2';
			name: Types.SportCompetitionStageName;
			number?: number | null;
		};
		pastEvents: Array<{
			__typename?: 'SingleStepSportEvent';
			id: string;
			objectId: number;
			objectType: Types.ObjectType;
			sport: Types.SportType;
			competition?: {
				__typename?: 'SportCompetitionV2';
				id: string;
				objectId: number;
				objectType: Types.ObjectType;
				sport: Types.SportType;
				content: { __typename?: 'SportCompetitionContentV2'; fullPath: string; name: string };
			} | null;
			competitors: {
				__typename?: 'SingleStepSportCompetitorsV2';
				homeTeam: {
					__typename?: 'SingleStepSportCompetitorV2';
					score?: number | null;
					competitors: Array<{
						__typename?: 'SportCompetitorV2';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						sport: Types.SportType;
						content: {
							__typename?: 'SportCompetitorContentV2';
							firstName: string;
							fullPath?: string | null;
							lastName: string;
							name: string;
							iconUrl?: string | null;
						};
					}>;
				};
				awayTeam: {
					__typename?: 'SingleStepSportCompetitorV2';
					score?: number | null;
					competitors: Array<{
						__typename?: 'SportCompetitorV2';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						sport: Types.SportType;
						content: {
							__typename?: 'SportCompetitorContentV2';
							firstName: string;
							fullPath?: string | null;
							lastName: string;
							name: string;
							iconUrl?: string | null;
						};
					}>;
				};
			};
			content: {
				__typename?: 'SingleStepSportEventContent';
				name: string;
				startAt: any;
				status: Types.SportEventStatus;
				season?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
			};
		}>;
	};
	mysportlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
	competition?: {
		__typename?: 'SportCompetitionV2';
		id: string;
		objectId: number;
		sport: Types.SportType;
		activeSeason?: { __typename?: 'SportSeason'; name: string; seasonID: number } | null;
		content: { __typename?: 'SportCompetitionContentV2'; name: string; fullPath: string; iconUrl?: string | null };
	} | null;
	competitors: {
		__typename?: 'SingleStepSportCompetitorsV2';
		homeTeam: {
			__typename?: 'SingleStepSportCompetitorV2';
			score?: number | null;
			winner: boolean;
			competitors: Array<{
				__typename?: 'SportCompetitorV2';
				id: string;
				objectId: number;
				content: {
					__typename?: 'SportCompetitorContentV2';
					name: string;
					iconUrl?: string | null;
					fullPath?: string | null;
				};
			}>;
		};
		awayTeam: {
			__typename?: 'SingleStepSportCompetitorV2';
			score?: number | null;
			winner: boolean;
			competitors: Array<{
				__typename?: 'SportCompetitorV2';
				id: string;
				objectId: number;
				content: {
					__typename?: 'SportCompetitorContentV2';
					name: string;
					iconUrl?: string | null;
					fullPath?: string | null;
				};
			}>;
		};
	};
	watchNowOffer?: {
		__typename?: 'SportOffer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		audioLanguage?: string | null;
		standardWebURL?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			technicalName: string;
			clearName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
			iconWide: string;
		};
	} | null;
	offers: Array<{
		__typename?: 'SportOffer';
		monetizationType: Types.MonetizationType;
		presentationType: Types.PresentationType;
		audioLanguage?: string | null;
		standardWebURL?: string | null;
		sportObjectType: Types.SportObjectType;
		package: {
			__typename?: 'Package';
			id: string;
			packageId: number;
			technicalName: string;
			clearName: string;
			shortName: string;
			monetizationTypes: Array<Types.MonetizationType>;
		};
	}>;
};

export const SingleStepSportEventFragmentDoc = gql`
	fragment SingleStepSportEvent on SingleStepSportEvent {
		__typename
		id
		objectType
		objectId
		sport
		content(country: $country, language: $language) {
			name
			status
			startAt
			endAt
			fullPath
			venue {
				venueID
				name
			}
			competitionStage {
				name
				number
			}
			pastEvents {
				id
				objectId
				objectType
				sport
				competition {
					id
					objectId
					objectType
					sport
					content(country: $country, language: $language) {
						fullPath
						name
					}
				}
				competitors {
					homeTeam {
						score
						competitors {
							id
							objectId
							objectType
							sport
							content(country: $country, language: $language) {
								firstName
								fullPath
								lastName
								name
								iconUrl
							}
						}
					}
					awayTeam {
						score
						competitors {
							id
							objectId
							objectType
							sport
							content(country: $country, language: $language) {
								firstName
								fullPath
								lastName
								name
								iconUrl
							}
						}
					}
				}
				content(country: $country, language: $language) {
					name
					startAt
					season {
						name
						seasonID
					}
					status
				}
			}
		}
		mysportlistEntry {
			createdAt
		}
		competition {
			id
			objectId
			sport
			activeSeason(country: $country, language: $language) {
				name
				seasonID
			}
			content(country: $country, language: $language) {
				name
				fullPath
				iconUrl
			}
		}
		...SingleStepSportEventParticipants
		...SportEventOffersV2
	}
	${SingleStepSportEventParticipantsFragmentDoc}
	${SportEventOffersV2FragmentDoc}
`;
